import type { CSSProperties } from 'react';
import { SearchMenuColumn } from './components/Columns';

const BENCHMARK_SEARCH_COLUMNS: SearchMenuColumn[] = [
  SearchMenuColumn.CCY,
  SearchMenuColumn.IDENTIFIER,
  SearchMenuColumn.TYPE,
  SearchMenuColumn.AVAILABLE_DATES,
  SearchMenuColumn.LAST_UPDATED,
];

const BENCHMARK_SEARCH_SMALL_SCREEN_COLUMNS: SearchMenuColumn[] = [
  SearchMenuColumn.CCY,
  SearchMenuColumn.IDENTIFIER,
  SearchMenuColumn.AVAILABLE_DATES,
];

interface BenchmarkSearchResponsiveProps {
  columns: SearchMenuColumn[];
  smallScreen: boolean | undefined;
  showQuickFilters: boolean;
  menuStyles: CSSProperties | undefined;
}

interface BenchmarkSearchResponsiveOptions {
  /**
   * Whether the small-screen menu is widened to a fixed 600px (anchored via `menuAnchor`). Defaults
   * to true. Set false when the search lives in a narrow container that the menu should match
   * instead of overflowing (e.g. the Portfolio Lab side panel) — the trimmed columns already keep
   * option names from truncating at the box width.
   */
  widenMenu?: boolean;
  /**
   * Which edge the widened small-screen menu anchors to. Only relevant when `widenMenu` is true.
   * Defaults to 'right'.
   */
  menuAnchor?: 'left' | 'right';
}

/**
 * Shared responsive config for the benchmark search dropdown. On small screens it drops the
 * Portfolio/Investment type column and hides quick filters; by default it also widens the menu so
 * option names aren't truncated inside a narrow container.
 */
export const getBenchmarkSearchResponsiveProps = (
  smallScreen?: boolean,
  { widenMenu = true, menuAnchor = 'right' }: BenchmarkSearchResponsiveOptions = {},
): BenchmarkSearchResponsiveProps => ({
  columns: smallScreen ? BENCHMARK_SEARCH_SMALL_SCREEN_COLUMNS : BENCHMARK_SEARCH_COLUMNS,
  smallScreen,
  showQuickFilters: !smallScreen,
  menuStyles:
    smallScreen && widenMenu
      ? { minWidth: '600px', position: 'absolute', ...(menuAnchor === 'left' ? { left: 0 } : { right: 0 }) }
      : undefined,
});
